import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
import { Formik } from "formik";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { Button, Divider, Grid } from "@material-ui/core";
import { withStyles, withTheme } from "@material-ui/core/styles";

import { addFeatureImageToDeal, updatePortfolioDeal, clearReload, getDealToSell, addSupplementalLoans, acknowledgeRedirect } from "../../store/state/deal";
import { updateProperty, createProperty, deleteProperty } from "../../store/state/property";
import placeholder from "../../lib/images/featured-image-tmp.png";
import FileUpload from "../Files/Upload";
import DealProperties from "../DealPipelineForm/Sections/DealProperties/DealProperties";
import Styles from "../Global/Fields/styles";
import SimpleConfirmDialog from "../Global/ConfirmationDialogs/SimpleConfirmDialog";
import DealAttachments from "../Global/OptionsMenu/DealTable/DealAttachments";
import DealNotes from "../Global/OptionsMenu/DealTable/DealNotes";
import SecondaryButton from "../Global/Buttons/SecondaryButton";

import ViewAndEditAssetDetails from "../Pipeline/ActiveDeal/components/ViewAndEditAssetDetails";
import PipelineActiveDealDetailsHeader, { VerticalDivider } from "../Pipeline/ActiveDeal/components/PipelineActiveDealDetailsHeader";
import SimpleInfoDialog from "../Global/ConfirmationDialogs/SimpleInfoDialog";
import ChangeDealStatusModal from "./ChangeDealStatusModal";
import SellDealWizardModal from "./SellDealWizardModal";
import ModifyLoansModal from "./ModifyLoansModal";
import PartialReleaseWizardModal from "./PartialReleaseWizardModal";

const styles = () => ({});

const StyledDiv = styled.div`
  margin: 5px 90px 0 10px;
`;

const StyledHeading = styled.div`
  font-size: 20px;
`;

const StyledEditButton = styled(Button)`
  && {
    color: white;
    background-color: rgba(0, 157, 223, 1);
    height: 22px;
    top: -26px;
    left: 92px;
  }
`;

const StyledCancelButton = styled(Button)`
  && {
    color: white;
    background-color: rgba(0, 157, 223, 1);
    height: 22px;
    top: -26px;
    width: 120px;
    left: calc(50% - 60px);
  }

  &&:hover {
    background-color: rgba(0, 157, 223, 1);
    cursor: pointer;
  }
`;

class DealViewAndEdit extends React.Component {
  constructor(props) {
    super(props);
    this.formik = React.createRef();
    this.state = {
      isNewDeal: true,
      isInitialized: false,
      isEditing: false,
      isEditImage: false,
      modalOpen: false,
      isNotesOpen: false,
      isAttachmentsOpen: false,
      popupOpen: false,
      changeStatusModalOpen: false
    };
  }

  handleRenderChangeStatusModalClose = closeChoice => {
    this.setState({ changeStatusModalOpen: false });
    switch (closeChoice) {
      case "sold":
        this.props.getDealToSell(this.props.deal.id);
        this.setState({ showSellDealModal: true });
        break;
      case "modify":
        this.setState({ showModifyLoansModal: true });
        break;
      case "addSupplemental":
        this.props.addSupplementalLoans(this.props.deal.id);
        break;
      case "partialRelease":
        this.props.getDealToSell(this.props.deal.id);
        this.setState({ showPartialReleaseModal: true });
      default:
        break;
    }
  };

  renderChangeStatusModal = () => {
    return (
      <ChangeDealStatusModal
        isOpen={this.state.changeStatusModalOpen}
        deal={this.props.deal}
        handleClose={this.handleRenderChangeStatusModalClose}
        history={this.props.history}
        shouldShowPartialRelease = {this.hasMultipleUnsoldProperties()}
      />
    );
  };

  hasMultipleUnsoldProperties = () => {
    let num = 0;
    this.props.deal.properties.forEach(property => {
      if(!property.actualExitDate) num++;
    });
    return num > 1
  }

  renderSellDealModal = () => {
    if (!this.state.showSellDealModal) {
      return null;
    }

    return <SellDealWizardModal onClose={() => this.setState({ showSellDealModal: false })} />;
  };

  renderPartialReleaseModal = () => {
    if(!this.state.showPartialReleaseModal) {
      return null;
    }

    return <PartialReleaseWizardModal onClose={() => {
      this.setState({showPartialReleaseModal: false});
      this.props.deal.properties.forEach(x => x.shouldDisposition=false);
    }} />
  }

  renderModifyLoansModal = () => {
    if (!this.state.showModifyLoansModal) {
      return null;
    }

    return <ModifyLoansModal onClose={() => this.setState({ showModifyLoansModal: false })} dealId={this.props.deal.id} history={this.props.history} />;
  };

  renderFeatureLockedModel = () => {
    return (
      <SimpleInfoDialog
        title="Feature Locked"
        message="This feature is only available if you upgrade your account."
        modalOpen={this.state.popupOpen}
        handleClose={this.closePopup}
        handleAccept={this.closePopup}
        secondaryContent={(
          <p>
            If you would to schedule a demo to view these features, contact <a href="mailto:sales@loanboss.com">sales@loanboss.com</a>. <br /> <br />
            Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error:{" "}
            <a href="mailto:support@loanboss.com">support@loanboss.com</a>.
          </p>
        )}
      />
    );
  };

  componentDidMount() {
    const shouldEditDeal = window.localStorage.getItem("shouldEditDeal");
    if (shouldEditDeal) {
      window.localStorage.removeItem("shouldEditDeal");
      this.setState({
        isEditing: true
      });
    }
  }

  componentDidUpdate() {
    if (this.props.reload) {
      this.props.clearReload();
      window.location.reload(false);
    }
    if (this.props.redirectTo) {
      this.props.acknowledgeRedirect();
      this.props.history.push(this.props.redirectTo);
    }
  }

  allowUploadNewImage = () => {
    this.setState({
      isEditImage: true
    });
  };

  handleUpload = files => {
    const { deal } = this.props;
    this.props.addFeatureImageToDeal("deal", deal.id, files[0], `/deals/${deal.id}/coverphoto/`, () => {
      this.props.refreshDeal();
    });
    this.setState({
      isEditImage: false
    });
  };

  editDeal = () => {
    this.setState({
      isEditing: true
    });
  };

  saveEditedDeal = () => {
    this.formik.current.submitForm();
  };

  cancelEditDeal = () => {
    this.setState({
      modalOpen: true
    });
  };

  cancelEditImage = () => {
    this.setState({
      isEditImage: false
    });
  };

  handleClose = () => {
    this.setState({
      modalOpen: false
    });
  };

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  revertForm = () => {
    this.formik.current.resetForm();
    this.setState({
      modalOpen: false,
      isEditing: false
    });
  };

  deleteFalsyValues = property => {
    this.deleteIfFalsy(property, "squareFeet");
    this.deleteIfFalsy(property, "units");
    this.deleteIfFalsy(property, "yearBuilt");
    this.deleteIfFalsy(property, "yearRenovated");
    this.deleteIfFalsy(property, "salesPrice");
    this.deleteIfFalsy(property, "noi");
    this.deleteIfFalsy(property, "noiActual");
    this.deleteIfFalsy(property, "appraisedValue");
    this.deleteIfFalsy(property, "purchasePrice");
    this.deleteIfFalsy(property, "landSize");
    this.deleteIfFalsy(property, "occupancy");
    this.deleteIfFalsy(property, "capExImprovements");
    this.deleteIfFalsy(property, "projectedExitDate");
    this.deleteIfFalsy(property, "actualExitDate");
    this.deleteIfFalsy(property, "purchaseDate");
    this.deleteIfFalsy(property, "noiAsOfDate");
    this.deleteIfFalsy(property, "marketValue");
    this.deleteIfFalsy(property, "marketValueAsOfDate");
    this.deleteIfFalsy(property, "noiAsOfappraisedValueAsOfDateDate");
  };

  deleteIfFalsy(property, fieldName) {
    if (!property[fieldName] && property[fieldName] !== 0) property[fieldName] = null;
  }

  onAddProperty = property => {
    const dealId = this.props.deal.id;
    this.deleteFalsyValues(property);
    const modifiedProperty = this.modifyPropertyPercentages(property);
    this.props.createProperty({
      dealId,
      ...modifiedProperty,
      callback: () => {
        this.props.refreshDeal();
      }
    });
  };

  onDeleteProperty = propertyId => {
    this.props.deleteProperty({
      id: propertyId,
      callback: () => {
        this.props.refreshDeal();
      }
    });
  };

  goToCashflows = () => {
    const { location, history } = this.props;
    history.push(`${location.pathname}/cashflowsPage?${location.search}`);
  };

  modifyPropertyPercentages = property => {
    const modified = { ...property };
    if (modified.occupancy) modified.occupancy /= 100;
    return modified;
  };

  onEditProperty = property => {
    const dealId = this.props.deal.id;
    this.deleteFalsyValues(property);
    const modifiedProperty = this.modifyPropertyPercentages(property);

    this.props.updateProperty({
      dealId,
      ...modifiedProperty,
      callback: () => {
        this.props.refreshDeal();
      }
    });
  };

  renderNotesAttachments() {
    const { isAttachmentsOpen, isNotesOpen } = this.state;
    const { deal, showNotesAttachments } = this.props;
    return showNotesAttachments ? (
      <>
        <DealAttachments dealId={deal.id} isOpen={isAttachmentsOpen} openAttachments={this.openAttachments} closeAttachments={this.closeAttachments} />
        <DealNotes dealId={deal.id} isOpen={isNotesOpen} openNotes={this.openNotes} closeNotes={this.closeNotes} />
      </>
    ) : null;
  }

  isProTier = () => {
    if (this.props.authentication) {
      return this.props.authentication.companyLevel === "Professional" 
      || this.props.authentication.companyLevel === "Enterprise"
      || this.props.authentication.companyLevel==="Secondary Sponsor";
    }
    return false;
  };

  openPopup = () => {
    this.setState({ popupOpen: true });
  };

  closePopup = () => {
    this.setState({ popupOpen: false });
  };

  openChangeStatusModal = () => {
    this.setState({ changeStatusModalOpen: true });
  };

  render() {
    const { isNewDeal, isInitialized, isEditing, modalOpen } = this.state;
    const { theme, deal, showNotesAttachments, guestPermissions, authentication } = this.props;

    if (_.isEmpty(deal)) return null;
    return (
      <>
        {this.renderNotesAttachments()}
        {this.renderChangeStatusModal()}
        {this.renderModifyLoansModal()}
        {this.renderSellDealModal()}
        {this.renderPartialReleaseModal()}
        <SimpleConfirmDialog
          title="Confirm Cancel"
          message="You are about to cancel all of your changes. Are you sure you want to do this?"
          noText="NO"
          yesText="YES, CANCEL"
          modalOpen={modalOpen}
          handleNo={this.handleClose}
          handleYes={this.revertForm}
        />
        <PipelineActiveDealDetailsHeader
          shouldShowChangeStatusButton={this.props.deal.dealStatus.value.toLowerCase() === "closed"}
          onChangeStatusClick={this.openChangeStatusModal}
          parent={this}
          dealId={deal.Id}
          title="General Info"
          isEditing={isEditing}
          editDeal={this.editDeal}
          cancel={this.cancelEditDeal}
          save={this.saveEditedDeal}
          openNotes={this.openNotes}
          openAttachments={this.openAttachments}
          guestPermissions={guestPermissions}
          authentication={authentication}
          optionalCashflows={(
            <>
              {(!authentication.isGuest || (authentication.isGuest && guestPermissions.canEdit)) && <VerticalDivider />}
              <SecondaryButton onClick={this.goToCashflows}>CASHFLOWS</SecondaryButton>
            </>
          )}
          showNotesAttachmentsLinks={showNotesAttachments}
          guestStore = {this.props.guestStore}
        />

        <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
          <Grid item lg={3} md={4} sm={4}>
            {this.state.isEditing && this.state.isEditImage ? (
              <StyledDiv>
                <FileUpload onDrop={this.handleUpload} />
                <StyledCancelButton variant="extendedFab" onClick={this.cancelEditImage}>
                  CANCEL
                </StyledCancelButton>
              </StyledDiv>
            ) : (
              <StyledDiv>
                <img src={deal.imageMedium || placeholder} alt="Featured" width="280" />
                {this.state.isEditing ? (
                  <StyledEditButton variant="extendedFab" onClick={this.allowUploadNewImage}>
                    EDIT IMAGE
                  </StyledEditButton>
                ) : null}
              </StyledDiv>
            )}
          </Grid>

          <Grid item lg={8} md={8} sm={8} xs={8}>
            <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
              <Grid item md={6} sm={12} xs={12}>
                <Formik
                  ref={this.formik}
                  initialValues={deal}
                  validate={values => {
                    const { funds, collaborationGroups } = values;
                    const error = {};
                    const selectedFundIds = funds.map(x => x.id);
                    const selectecCollabGroupsIds = collaborationGroups.map(x=>x.id);
                    const dupedFundIds = _.filter(selectedFundIds, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
                    const dupedCollabGroupIds = _.filter(selectecCollabGroupsIds, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
                    for (let i = 0; i < funds.length; i++) {
                      const curFund = funds[i];
                      if (!curFund.id) error[`funds[${i}].id`] = "Required";
                      else if (dupedFundIds.indexOf(curFund.id) > -1) error[`funds[${i}].id`] = "Duplicate group selected";
                      else delete error[`funds[${i}].id`];

                      if (!curFund.fundDealBridge.allocationPercent) error[`funds[${i}].fundDealBridge.allocationPercent`] = "Required";
                      else if (curFund.fundDealBridge.allocationPercent < 0.01 || curFund.fundDealBridge.allocationPercent > 100)
                        error[`funds[${i}].fundDealBridge.allocationPercent`] = "Must be between 0.01% and 100%";
                      else delete error[`funds[${i}].fundDealBridge.allocationPercent`];
                    }
                    for (let i = 0; i < collaborationGroups.length; i++) {
                      const curGroup = collaborationGroups[i];
                      if (!curGroup.id) error[`collaborationGroups[${i}].id`] = "Required";
                      else if (dupedCollabGroupIds.indexOf(curGroup.id) > -1) error[`collaborationGroups[${i}].id`] = "Duplicate group selected";
                      else delete error[`collaborationGroups[${i}].id`];
                    }
                    return error;
                  }}
                  onSubmit={(values, actions) => {
                    const modifiedValues = _.cloneDeep(values);
                    modifiedValues.fundId = modifiedValues.fundId ? modifiedValues.fundId.value : null;
                    modifiedValues.dealStatusId = modifiedValues.dealStatusId ? modifiedValues.dealStatusId : null;
                    modifiedValues.stageId = modifiedValues.stageId ? modifiedValues.stageId : null;
                    modifiedValues.projectTypeId = modifiedValues.projectTypeId ? modifiedValues.projectTypeId : null;
                    for (let i = 0; i < modifiedValues.funds.length; i++) {
                      modifiedValues.funds[i].fundDealBridge.allocationPercent /= 100;
                    }
                    for (let i = 0; i < modifiedValues.collaborationGroups.length; i++) {
                      modifiedValues.collaborationGroups[i].fundDealBridge.allocationPercent /= 100;
                      if( modifiedValues.collaborationGroups[i].fundDealBridge.allocationPercent > 1) {
                         modifiedValues.collaborationGroups[i].fundDealBridge.allocationPercent = 1;
                        }
                    }
                    delete modifiedValues.properties; // need to delete properties before updating deal since it won't have the updated information.
                    this.props.updatePortfolioDeal(modifiedValues, { dealId: deal.id });
                    this.setState({
                      isEditing: false,
                      isEditImage: false
                    });
                    actions.setSubmitting(false);
                  }}
                  render={({ values, handleChange, setFieldValue }) => (
                    <Styles theme={theme}>
                      <div>
                        <ViewAndEditAssetDetails
                          values={values}
                          dealId={deal.id}
                          isNewDeal={isNewDeal}
                          isEditing={isEditing}
                          isInitialized={isInitialized}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          guestPermissions={guestPermissions}
                        />
                      </div>
                    </Styles>
                  )}
                />
              </Grid>

              <Grid item md={6} sm={12} xs={12}>
                <StyledHeading>Properties</StyledHeading>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <DealProperties
                  onAddProperty={this.onAddProperty}
                  onEditProperty={this.onEditProperty}
                  onDeleteProperty={this.onDeleteProperty}
                  isViewOnlyMode={!isEditing}
                  properties={deal.properties}
                  deal={deal}
                  guestPermissions={guestPermissions}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {this.renderFeatureLockedModel()}
      </>
    );
  }
}

const mapStateToProps = ({ authentication, deal, guest }) => ({
  authentication,
  guestStore: guest,
  reload: deal.reloadDeal
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    clearReload,
    acknowledgeRedirect,
    getDealToSell,
    addSupplementalLoans,
    updatePortfolioDeal,
    addFeatureImageToDeal,
    updateProperty,
    createProperty,
    deleteProperty
  }),
  withStyles(styles),
  withTheme()
)(DealViewAndEdit);
